import HttpClient from '@/utility/http-client';

export default {
    getList(page: number, rowPerPage: number, filters: any[], quickFilters: any[]) {
        const filter = filters && filters.length > 0 ? Buffer.from(JSON.stringify({ filter: filters })).toString('base64') : '';
        const quickFilter = quickFilters && quickFilters.length > 0 ? Buffer.from(JSON.stringify({ filter: quickFilters })).toString('base64') : '';
        const url = `/api/export_receipt/?filter=${filter}&page=${page}&rowsPerPage=${rowPerPage}&q=${quickFilter}`;
        return HttpClient.instance().get(url);
    },

    getDetail(id: string) {
        const url = `/api/export_receipt/${id}`;
        return HttpClient.instance().get(url);
    },

    getBillOfLading(receiptId: string, token: any = null) {
        let url = `/api/order_transactions?ReceiptID=${receiptId}`
        if(token) {
            url += `&token=${token}`;
        }
        return HttpClient.instance().get(url);
    },
};
